import wrapperRequest from '@/utils/request';

export async function fileUpload(params: any) {
  const formData = new FormData();

  // Thêm các tham số vào FormData
  formData.append('dir', params.dir);

  // Xử lý files (có thể là single file hoặc array)
  if (Array.isArray(params.files)) {
    params.files.forEach((file: any) => {
      formData.append('files', file);
    });
  } else {
    formData.append('files', params.files);
  }

  if (params.maxSize) {
    formData.append('maxSize', params.maxSize);
  }

  if (params.type) {
    formData.append('type', params.type);
  }

  const res = await wrapperRequest<any>('/erpanlam-hrm/file-manager/upload', {
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return res;
}

export async function fileDelete(filePath: any) {
  const res = await wrapperRequest<any>('/erpanlam-hrm/file-manager/delete-file', {
    method: 'GET',
    params: {
      filePath,
    },
  });
  return res;
}

export const getFile = (filePath: any) => {
  return wrapperRequest<any>('/erpanlam-hrm/file-manager/get-file/' + filePath, {
    method: 'GET',
    responseType: 'blob',
  });
};
